import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const CustomersEntityLink = () => {

  return (
    <AsideMenuLink
      pathname={P.CUSTOMERS_ENTITY_PAGE}
      subject={S.CUSTOMERS_ENTITY_PAGE}
      icon={'Group_pink.svg'}
      label={<FormattedMessage id="customers-entity-page-link" defaultMessage="Customers entity"/>}
    />
  );
};

export default CustomersEntityLink;
